// Extract data from API response if status is OK

export enum ResponseStatus {
  OK = 200,
}

export const maybeGetResponseData = (res: any) =>
  res.status === ResponseStatus.OK && res.data;
